// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-cd56bab8]{align-items:center;background:#f8f9fa;border:1px solid #e9ecef;border-radius:4px;color:#adb5bd;display:flex;flex-direction:column;gap:16px;height:171px;justify-content:center;margin:20px 0;padding:32px 20px;text-align:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
